import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=0221e97f&scoped=true&"
import script from "./public-header.ts?vue&type=script&lang=ts&"
export * from "./public-header.ts?vue&type=script&lang=ts&"
import style0 from "./public-header.scss?vue&type=style&index=0&id=0221e97f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221e97f",
  null
  
)

export default component.exports